import { LocalizationProvider } from '@mui/x-date-pickers'
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Col, Row } from 'react-bootstrap'
import dayjs from 'dayjs'
import { AuctionBase } from '../../../app/models/Auction'
import { AuctionCreationDatePickersInterface } from '../../../app/models/date'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Tooltip } from '@mui/material'

interface Props {
  dates: AuctionCreationDatePickersInterface[]
  setAuction: any
  auction: AuctionBase
  deadlineToShow?: Date
}

enum DateInput {
  AuctionStart = 0,
  AuctionEnd = 1
}

function AuctionCreateDates({ dates, setAuction, auction, deadlineToShow }: Props) {
  return (
    <div className='auction-create-dates'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DateTimePicker']}>
          <Row>
            {dates.map(
              (date, index) =>
                 (
                  <Col key={index} lg={date.lg} style={date.style}>
                    <DemoItem
                      label={
                        <span className='date-label'>
                          <span>{date.label}</span>
                          {date.tooltip && (
                            <Tooltip className='mx-2' title={date.tooltip}>
                              <HelpOutlineIcon />
                            </Tooltip>
                          )}
                        </span>
                      }
                    >
                      <DateTimePicker
                        className='dateTime'
                        value={dayjs(auction.totalRounds > 1 && index === DateInput.AuctionEnd ? deadlineToShow : date.value)}
                        disabled={date.disabled}
                        minDate={dayjs()}
                        onChange={(newValue: dayjs.Dayjs | null) => {
                          setAuction({
                            ...auction,
                            [date.onChange]: newValue?.toDate(),
                          })
                        }}
                      />
                    </DemoItem>
                  </Col>
                ),
            )}
          </Row>
        </DemoContainer>
      </LocalizationProvider>
    </div>
  )
}
export default AuctionCreateDates
